
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetomahabaleshwarcab() {



    const cardData =
    {
        keyword: 'Pune to Mahabaleshwar Cab',
        heading: 'Meghana Cab : Pune to Mahabaleshwar Cab',
        headingDescription: 'Meghana Cab offers Pune to Mahabaleshwar Cab services, ensuring a scenic, comfortable, and relaxed journey to the lush hill station. Whether you are planning a weekend getaway, family trip, or romantic escape, our clean and well-maintained cabs with experienced drivers ensure a smooth and enjoyable ride. Choose from a variety of vehicle options to suit your group size and preferences, and enjoy transparent pricing, punctual pickups, and 24/7 customer support. Book your Pune to Mahabaleshwar Cab with Meghana Cab and experience nature’s beauty in comfort and convenience.',


        top: 'Top Places to Visit in Mahabaleshwar with Meghana Cab',

"topPlaces": [
  {
    "title": "Wilson Point",
    "description": "The highest point in Mahabaleshwar at about 1,439 m, named after Governor Leslie Wilson. It’s the best spot for sunrise views over the Western Ghats and the town below."
  },
  {
    "title": "Arthur’s Seat",
    "description": "This cliff offers dramatic views of the deep valleys between the Savitri River and the dense Sahyadri ranges. Known as the 'Queen of Points', it features the floating rock phenomenon."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "Also called Needle Hole Point due to its elephant-trunk-shaped rock formation. It provides spectacular valley vistas and is ideal for morning or evening photography."
  },
  {
    "title": "Lodwick Point",
    "description": "Formerly Sydney Point, this lesser-known vantage overlooks Pratapgad Fort and Elphinstone Point. It’s quieter and offers peaceful views of the surrounding valleys."
  },
  {
    "title": "Venna Lake",
    "description": "An artificial lake built in 1842 by the Satara ruler. Popular for boating, lakeside horse rides, and nearby food stalls. It also serves as a starting point for lakeside walks and solo relaxation."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "A monsoon-fed waterfall about 500 ft high located near Venna Lake. It includes a mini fall pool and a main cascading drop, accessible via a 30-minute walk, surrounded by lush greenery."
  },
  {
    "title": "Mahabaleshwar Temple",
    "description": "A 16th-century temple dedicated to Lord Shiva, built by the More dynasty. It features a historic Shivling and central to local religious activity, drawing pilgrims year-round."
  },
  {
    "title": "Pratapgad Fort",
    "description": "About 24 km away, this historic hill fort was built in 1656 by Shivaji Maharaj. Famous as the site where Shivaji defeated Afzal Khan, the fort offers rugged ruins, temples, and panoramic views."
  },
  {
    "title": "Panchgani & Table Land",
    "description": "Neighboring hill station Panchgani is famous for Table Land—Asia’s second-largest volcanic plateau. It also hosts Kate’s Point, Echo Point, Monkey Point, and Parsi Point nearby."
  },
  {
    "title": "Strawberry Farms & Mapro Garden",
    "description": "Mahabaleshwar is renowned for strawberries, contributing around 85% of India’s production. Mapro Garden and local farms allow berry picking, fresh fruit treats, jams, and fudge tasting."
  }
],

  "services": [
    {
      "name": "Pune to Trimbakeshwar Cab Price",
      "description": "The one-way cab fare from Pune to Trimbakeshwar starts at ₹2,200, depending on the vehicle type and service provider. Round-trip fares typically range from ₹4,500 to ₹7,500, offering flexibility for pilgrims and tourists alike."
    },
    {
      "name": "Affordable Taxi Fare Pune to Trimbakeshwar",
      "description": "Budget-friendly taxi options are available, with fares starting from ₹2,200 for a one-way trip. Providers like Tiger Cabs and GaadiCab offer competitive pricing without compromising on comfort or safety."
    },
    {
      "name": "One Way Cab Fare Pune to Trimbakeshwar",
      "description": "One-way cab fares from Pune to Trimbakeshwar vary based on vehicle type and provider. For instance, GaadiCab offers sedan fares starting at ₹2,500, while Uber Intercity's fares begin around ₹4,451."
    },
    {
      "name": "Round Trip Fare Pune to Trimbakeshwar",
      "description": "Round-trip fares for a Pune to Trimbakeshwar journey can range from ₹4,500 to ₹7,500, depending on the vehicle and service provider. For example, MakeMyTrip lists SUV round-trip fares starting at ₹4,670."
    },
    {
      "name": "Online Fare Estimate Pune to Trimbakeshwar",
      "description": "Online platforms like MakeMyTrip and Uber Intercity provide fare estimates for Pune to Trimbakeshwar trips. For instance, Uber Intercity offers fares starting at ₹4,451 for a one-way trip."
    },
    {
      "name": "Pune to Trimbakeshwar AC Cab Fare",
      "description": "AC cab fares for the Pune to Trimbakeshwar route vary by vehicle type. For example, Payal Cab offers AC sedan fares starting at ₹3,499, while Clear Cabs Rental lists AC sedan fares at ₹3,499 for a one-way trip."
    },
    {
      "name": "SUV Taxi Pune to Trimbakeshwar Price",
      "description": "SUV taxi fares for the Pune to Trimbakeshwar route start from ₹3,999 for a one-way trip. Providers like Payal Cab and Clear Cabs Rental offer SUVs such as Toyota Innova and Mahindra Xylo for this route."
    },
    {
      "name": "Best Cab Rate Pune to Trimbakeshwar",
      "description": "The best cab rates for the Pune to Trimbakeshwar route depend on vehicle type and service provider. For instance, GaadiCab offers sedan fares starting at ₹2,500, while Uber Intercity's fares begin around ₹4,451."
    },
    {
      "name": "Pune to Trimbakeshwar Sedan Fare",
      "description": "Sedan fares for the Pune to Trimbakeshwar route start from ₹2,500 for a one-way trip. Providers like GaadiCab and Payal Cab offer sedan options such as Swift Dzire and Toyota Etios for this route."
    },
    {
      "name": "Transparent Pricing Pune to Trimbakeshwar",
      "description": "Service providers like Tiger Cabs and Clear Cabs Rental offer transparent pricing with no hidden charges. For example, Clear Cabs Rental lists sedan fares at ₹3,499 for a one-way trip, inclusive of driver allowance."
    },
    {
      "name": "Fare Comparison Pune to Trimbakeshwar Taxi",
      "description": "Comparing fares from different providers can help you find the best deal. For instance, Uber Intercity offers fares starting at ₹4,451, while Payal Cab lists sedan fares at ₹3,499 for a one-way trip."
    },
    {
      "name": "Pune to Trimbakeshwar Car Hire Cost",
      "description": "Car hire costs for the Pune to Trimbakeshwar route vary based on vehicle type and provider. For example, DDcab offers sedan hire starting at ₹3,788, while Clear Cabs Rental lists sedan fares at ₹3,499 for a one-way trip."
    },
    {
      "name": "Cheap Pune to Trimbakeshwar Cab",
      "description": "Affordable cab options are available for the Pune to Trimbakeshwar route, with fares starting from ₹2,200 for a one-way trip. Providers like Tiger Cabs and GaadiCab offer competitive pricing without compromising on comfort."
    },
    {
      "name": "Toll Charges Included Fare Pune to Trimbakeshwar",
      "description": "Some service providers include toll charges in their fares. For instance, Clear Cabs Rental lists sedan fares at ₹3,499 for a one-way trip, inclusive of driver allowance, but excludes toll and parking charges."
    },
    {
      "name": "Trimbakeshwar Darshan Cab Fare from Pune",
      "description": "Cab fares for Trimbakeshwar Darshan from Pune vary based on vehicle type and provider. For example, Payal Cab offers sedan fares starting at ₹3,499 for a one-way trip, while Clear Cabs Rental lists sedan fares at ₹3,499 for a one-way trip."
    }
  ],

  "tableData": [
    ["Service Provider", "Vehicle Type", "One-Way Fare (₹)", "Round-Trip Fare (₹)", "Additional Charges"],
    ["GaadiCab", "Sedan", "2,500", "5,000", "Toll, Parking, Driver Allowance"],
    ["Uber Intercity", "Sedan", "4,451", "8,902", "Toll, Parking, Driver Allowance"],
    ["Payal Cab", "Sedan", "3,499", "6,998", "Toll, Parking, Driver Allowance"],
    ["Clear Cabs Rental", "Sedan", "3,499", "6,998", "Toll, Parking, Driver Allowance"],
    ["Tiger Cabs", "Sedan", "2,200", "4,400", "Toll, Parking, Driver Allowance"]
  ],









"whychoose": [
    {
        "WhyChooseheading": "Comfortable Pune to Mahabaleshwar Cab Service",
        "WhyChoosedescription": "Meghana Cab offers reliable and luxurious cab services from Pune to Mahabaleshwar—perfect for weekend getaways, family trips, or romantic hill station retreats. Enjoy a scenic drive through the Western Ghats in total comfort."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Cab Fares",
        "WhyChoosedescription": "We provide fixed and all-inclusive Pune to Mahabaleshwar cab fares, covering tolls, fuel, and driver allowance—no hidden charges, ever. Choose the vehicle that fits your budget and travel style."
    },
    {
        "WhyChooseheading": "Wide Range of Cab Options",
        "WhyChoosedescription": "Whether you need an economical hatchback, a comfortable sedan, a spacious SUV, or a tempo traveller for a group, Meghana Cab has you covered. Each vehicle is air-conditioned, sanitized, and ideal for hill travel."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Ghat and Hill Station Routes",
        "WhyChoosedescription": "Our drivers are skilled in navigating the curvy ghat roads safely and efficiently. With route knowledge and attention to passenger comfort, they make your journey to Mahabaleshwar smooth and enjoyable."
    },
    {
        "WhyChooseheading": "Doorstep Pickup from Anywhere in Pune",
        "WhyChoosedescription": "Get picked up directly from your home, office, hotel, or airport in Pune. We ensure a punctual and stress-free start to your Mahabaleshwar vacation."
    },
    {
        "WhyChooseheading": "Flexible Booking Options: One-Way, Round Trip & Overnight Stays",
        "WhyChoosedescription": "Whether you're planning a day trip, an overnight stay, or a weekend escape, we offer custom cab packages to suit your itinerary. Return at your convenience with our flexible round-trip options."
    },
    {
        "WhyChooseheading": "24/7 Cab Availability and Easy Booking",
        "WhyChoosedescription": "Travel anytime with Meghana Cab’s 24/7 availability. Book easily via our app, website, or by calling us directly. Get instant confirmations, driver details, and real-time tracking."
    },
    {
        "WhyChooseheading": "Ideal for Families, Couples & Group Travelers",
        "WhyChoosedescription": "Mahabaleshwar is a favorite for nature lovers and families alike. Our cab services cater to all kinds of travelers with comfortable rides, safe driving, and personalized support throughout the journey."
    }
]










































    }

const faqData = [
    {
        question: "How can I book a cab from Pune to Mahabaleshwar with Meghana Cab?",
        answer: "You can easily book a Pune to Mahabaleshwar cab by calling Meghana Cab at +91 9075462128 or through our website."
    },
    {
        question: "What types of vehicles are available for Pune to Mahabaleshwar trips?",
        answer: "We offer sedans, SUVs, and tempo travellers depending on your group size and comfort requirements."
    },
    {
        question: "Are Meghana Cab drivers familiar with the Pune to Mahabaleshwar route?",
        answer: "Yes, our drivers know the best routes to ensure a safe and timely journey to Mahabaleshwar."
    },
    {
        question: "Can I book a one-way or round-trip cab from Pune to Mahabaleshwar?",
        answer: "Yes, both one-way and round-trip cab services are available."
    },
    {
        question: "What is included in the Pune to Mahabaleshwar cab fare?",
        answer: "The fare includes driver charges, fuel, tolls, and vehicle maintenance. Additional charges may apply depending on your trip."
    },
    {
        question: "Are the vehicles sanitized for Pune to Mahabaleshwar trips?",
        answer: "Yes, all vehicles are regularly cleaned and sanitized to ensure your safety and comfort."
    },
    {
        question: "Is Meghana Cab available 24/7 for Pune to Mahabaleshwar bookings?",
        answer: "Yes, our services operate round-the-clock to accommodate your travel needs."
    },
    {
        question: "Can I request special requirements like child seats for Pune to Mahabaleshwar trips?",
        answer: "Yes, special requests can be made during booking."
    },
    {
        question: "What payment methods are accepted for Pune to Mahabaleshwar cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
    {
        question: "How can I contact Meghana Cab for Pune to Mahabaleshwar cab services?",
        answer: "Call Meghana Cab at +91 9075462128 to book or inquire about Pune to Mahabaleshwar cab services."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Suresh Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Pune to Mahabaleshwar cab service by Meghana Cab was comfortable and reliable.”',
    },
    {
        name: 'Ms. Priya Deshmukh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Highly recommend Meghana Cab for trips to Mahabaleshwar. Friendly driver and clean vehicle.”',
    },
];







































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const cabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": "https://www.meghanacabs.com/pune-to-mahabaleshwar-cab#service",
  "serviceType": "Pune to Mahabaleshwar Cab",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com/"
  },
  "areaServed": ["Pune","Mahabaleshwar","Panchgani","Wai","Satara","Maharashtra"],
  "description": "Reliable Pune to Mahabaleshwar cab—one-way or round trip—with clean AC Sedan & SUV, transparent fares, scenic ghat route via Wai–Panchgani, and 24x7 support.",
  "offers": {
    "@type": "AggregateOffer",
    "priceCurrency": "INR",
    "lowPrice": "2499",
    "highPrice": "6499",
    "offerCount": "10",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-mahabaleshwar-cab"
  },
  "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.9", "ratingCount": 6058 }
};

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://www.meghanacabs.com/#biz",
  "name": "Meghana Cabs",
  "url": "https://www.meghanacabs.com/",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-mahabaleshwar-cab.jpg",
  "priceRange": "₹₹",
  "address": { "@type": "PostalAddress", "addressLocality": "Pune", "addressRegion": "MH", "addressCountry": "IN" },
  "areaServed": ["Pune","Mahabaleshwar","Panchgani","Wai","Satara"],
  "openingHoursSpecification": [{
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
    "opens": "00:00", "closes": "23:59"
  }],
  "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.8", "ratingCount": 7024 }
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.meghanacabs.com/" },
    { "@type": "ListItem", "position": 2, "name": "Pune to Mahabaleshwar Cab", "item": "https://www.meghanacabs.com/pune-to-mahabaleshwar-cab" }
  ]
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What are the starting fares for Pune to Mahabaleshwar?",
      "acceptedAnswer": { "@type": "Answer", "text": "Sedan one-way fares typically start around ₹2499. Final price depends on cab type, date, and pickup/drop locations." }
    },
    {
      "@type": "Question",
      "name": "How long does the trip take?",
      "acceptedAnswer": { "@type": "Answer", "text": "Usually 4–6 hours depending on traffic and stops on the Wai–Panchgani ghat route." }
    },
    {
      "@type": "Question",
      "name": "Do you offer one-way, round trip, and multi-day packages?",
      "acceptedAnswer": { "@type": "Answer", "text": "Yes. Choose one-way drop, round trip, or multi-day sightseeing with clear waiting and driver allowance terms." }
    },
    {
      "@type": "Question",
      "name": "Which cab types are available?",
      "acceptedAnswer": { "@type": "Answer", "text": "Clean AC Sedan, SUV, and premium cars with verified professional drivers. Select as per passengers and luggage." }
    }
  ]
};






    return (
        <div>

<Helmet>
  <title>Pune to Mahabaleshwar Cab | One Way & Round Trip Taxi | Meghana Cabs</title>
  <meta
    name="description"
    content="Book Pune to Mahabaleshwar cab for one-way or round trip. AC Sedan & SUV, scenic ghat route via Wai–Panchgani, transparent fares, verified drivers, 24x7 support."
  />
  <link rel="canonical" href="https://www.meghanacabs.com/pune-to-mahabaleshwar-cab" />
  <meta name="robots" content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" />

  {/* Optional meta keywords */}
  <meta
    name="keywords"
    content="Pune to Mahabaleshwar Cab, Pune to Mahabaleshwar Taxi, One Way Cab Pune to Mahabaleshwar, Round Trip Taxi Pune Mahabaleshwar, Sedan SUV Cab Mahabaleshwar, Pune to Panchgani Cab"
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta property="og:title" content="Pune to Mahabaleshwar Cab | Meghana Cabs" />
  <meta
    property="og:description"
    content="Reliable Pune → Mahabaleshwar taxi: one-way & round trip, AC Sedan & SUV, transparent fares, 24x7 support."
  />
  <meta property="og:url" content="https://www.meghanacabs.com/pune-to-mahabaleshwar-cab" />
  <meta property="og:image" content="https://www.meghanacabs.com/assets/images/pune-to-mahabaleshwar-cab.jpg" />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Pune to Mahabaleshwar Cab | Meghana Cabs" />
  <meta
    name="twitter:description"
    content="Book Pune → Mahabaleshwar cabs—one-way & round trip with AC Sedan & SUV and verified drivers."
  />
  <meta name="twitter:image" content="https://www.meghanacabs.com/assets/images/pune-to-mahabaleshwar-cab.jpg" />

  {/* JSON-LD */}
  <script type="application/ld+json">{JSON.stringify(cabServiceSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(localBusinessSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/38.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomahabaleshwarcab;